import PropTypes from 'prop-types';
import React from 'react';
import { RowDefinition, ColumnDefinition } from 'griddle-react';
import {
  ButtonGroup,
  Button,
} from 'react-bootstrap';

import { fullDate, getCurrentDate } from '../../../core/date';
import StyledGriddle from '../../../components/StyledGriddle';
import { findById } from '../../../core/utils';

const sortProperties = [
  { id: 'start', sortAscending: true },
  { id: 'group', sortAscending: true },
  { id: 'name', sortAscending: true },
];


const dateDisplay = ({ value }) => {
  return (
    <span> {fullDate(value)} </span>
  )
}

class CommissionTable extends React.Component {
  constructor(props) {
    super(props);
    this.markAsPaid = this.markAsPaid.bind(this);
  }
  markAsPaid(e) {
    e.preventDefault();
    const bidId = e.currentTarget.getAttribute('data-item');
    const payload = { paid: getCurrentDate() };
    this.props.editCommission(bidId, payload);
  }
  render() {
    const ButtonColumn = ({ value }) => {
      if (value) {
        return (
          <ButtonGroup>
            <Button bsStyle="success" data-item={value} onClick={this.markAsPaid} title="Mark as Paid">
              <i className="fa fa-check fa-lg" /> Paid
            </Button>
          </ButtonGroup>
        );
      }
      return null;
    };
    const data = [];
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      // the default value for minimumFractionDigits depends on the currency
      // and is usually already 2
    });
    this.props.commissions.forEach((commission) => {
      const id = (commission.state !== 'PAID') ? commission.bid.id : null;
      const newRow = {
        id,
        name: commission.bid.hotel.name,
        value: formatter.format(commission.value),
        due: commission.due,
        end: commission.bid.bidset.event.end,
        state: commission.state,
        tour: commission.tour,
      };
      data.push(newRow);
    });
    // <ColumnDefinition id="id" title=" " order={10} customComponent={ButtonColumn} />

    return (
      <div>
        <StyledGriddle
          data={data}
          sortProperties={sortProperties}
        >
          <RowDefinition>
            <ColumnDefinition id="name" title="Hotel" order={1} />
            <ColumnDefinition id="value" title="$" order={2} />
            <ColumnDefinition id="due" title="Due Date" order={3} customComponent={dateDisplay} />
            <ColumnDefinition id="end" title="Check Out" order={5} customComponent={dateDisplay} />
            <ColumnDefinition id="state" title="Status" order={6} />
            <ColumnDefinition id="tour" title="Tour" order={7} />
            <ColumnDefinition id="id" title=" " order={10} customComponent={ButtonColumn} />
          </RowDefinition>
        </StyledGriddle>
      </div>
    );
  }
}

CommissionTable.propTypes = {
  commissions: PropTypes.arrayOf(PropTypes.object).isRequired,
  editCommission: PropTypes.func.isRequired,
};

export default CommissionTable;



// WEBPACK FOOTER //
// src/routes/commissions/components/CommissionTable.js